import React, { useEffect, useState } from 'react';
import { getUserMovementVideo } from '../../services/EditReportServices';
import noVideoFound from '../../assets/Icons/noVideoFound.svg';

const UserVideoView = ({ exerciseId, sessionId, userId }) => {
  const [videoUrl, setVideoUrl] = useState('');
  const [videoFound, setVideoFound] = useState(true);
  useEffect(() => {
    getUserMovementVideo(userId, sessionId, exerciseId).then((res) => {
      console.log('res', res.data);
      if (res && res.data && res.data.data) {
        setVideoFound(true);
        setVideoUrl(res.data.data);
      } else {
        setVideoFound(false);
      }
    });
  }, []);

  return (
    <>
      {videoFound ? (
        <video
          controls
          className='w-[620px] h-[310px] rounded-[18px]'
          src={videoUrl}
        ></video>
      ) : (
        <div className='w-[620px] h-[310px] object-fill rounded-[18px] bg-[#f5f5f5] flex-col flex justify-center items-center gap-2'>
          <img src={noVideoFound} alt='' height={104} width={104} />
          <div className='opacity-70 text-[#6A6A6A] text-sm font-medium'>
            Preview not Available
          </div>
        </div>
      )}
    </>
  );
};

export default UserVideoView;
